// extracted by mini-css-extract-plugin
export default {"dataGridTile":"x5V4IIB1Vc07wLAjedYA"};